import { useEffect, useState } from 'react'
import { formatCountdown } from '@/lib/storm/format'

/**
 * Live countdown to an ISO target — re-renders on an interval so an "expires in 1h 12m"
 * readout ticks down. Returns null when there's no target. Ticks every 15s (minute
 * resolution display; cheap, battery-friendly).
 */
export function useCountdown(targetIso: string | null | undefined, intervalMs = 15_000): string | null {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!targetIso) return
    const t = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(t)
  }, [targetIso, intervalMs])

  if (!targetIso) return null
  const target = Date.parse(targetIso)
  if (!Number.isFinite(target)) return null
  return formatCountdown(target - now)
}
